import styled from 'styled-components';

import {
  icons,
} from 'web-styled';


export const Icon = styled.div`
  width: 50px;
  height: 50px;
  background-size: cover;
  background-image: url(${icons.emptyVideoSearch});
`;
